import React from 'react';
import { filasResumen, type ResumenTipoCaso } from './metricas';

/**
 * Tabla de métricas: una fila por métrica (orden y formato de `filasResumen`) y una
 * columna por lo que se compare — tipo de caso (Corridas: Editadas | Control) o
 * corrida (Comparar: una por corrida). Una fila con valores distintos entre columnas va
 * en negrita, para que la diferencia salte a la vista. `extra` agrega filas calculadas
 * afuera (ej. "Coincide con mi análisis"), un valor por columna.
 */
const ResumenMetricas: React.FC<{
  titulo?: string;
  columnas: Array<{ titulo: string; resumen: ResumenTipoCaso }>;
  extra?: Array<{ etiqueta: string; valores: string[] }>;
}> = ({ titulo, columnas, extra = [] }) => {
  const filas = columnas.map((c) => filasResumen(c.resumen));
  const etiquetas = [...(filas[0]?.map(([k]) => k) ?? []), ...extra.map((e) => e.etiqueta)];
  const nBase = filas[0]?.length ?? 0;
  return (
    <div className="overflow-x-auto">
      {titulo && <h4 className="mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500">{titulo}</h4>}
      <table className="w-full text-xs">
        <thead>
          <tr className="text-left text-gray-500">
            <th className="py-1 pr-3 font-medium">Métrica</th>
            {columnas.map((c) => (
              <th key={c.titulo} className="py-1 pr-3 font-medium text-brand-black">
                {c.titulo}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {etiquetas.map((k, i) => {
            const valores = i < nBase ? filas.map((f) => f[i]?.[1] ?? '—') : columnas.map((_, j) => extra[i - nBase]?.valores[j] ?? '—');
            const difieren = valores.length > 1 && new Set(valores).size > 1;
            return (
              <tr key={k} className="border-t border-gray-100">
                <td className="py-1 pr-3 text-gray-500">{k}</td>
                {valores.map((v, j) => (
                  <td key={j} className={`py-1 pr-3 tabular-nums text-brand-black ${difieren ? 'font-semibold' : ''}`}>
                    {v}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ResumenMetricas;
